<template>
  <div class="step-layout" id="app">
    <!-- ---------------------------- Step Intro Section ---------------------------- -->
    <section class="step-layout-left bg-3">
      <div class="step-layout-container">
        <!-- Progressbar -->
        <div class="progressbar">
          <ul>
            <li class="completed">Your city {{ selectedCity }}</li>
            <li class="completed">Contact Details</li>
            <li class="completed">Home Type</li>
            <li class="active">Sell Date</li>
            <li>Other Details</li>
            <li>Home Details</li>
          </ul>
        </div>
        <!-- Intro Title -->
        <h2
          class="text-white intro-title d-none d-sm-block"
          data-aos="fade-up"
          data-aos-duration="1300"
        >
          Sell in a matter of davs or plan <br />well in advance. You
          control<br />
          the timeline.
        </h2>
        <h2
          class="text-white intro-title d-block d-sm-none text-center"
          data-aos="zoom-in"
          data-aos-duration="1300"
        >
          Sell in a matter of davs or plan well in advance. You control the
          timeline.
        </h2>

        <!-- Back Button -->
        <div
          class="text-center text-sm-left"
          data-aos="fade-up"
          data-aos-duration="1600"
        >
          <a href="javascript:void(0)" class="btn btn-primary" v-on:click="goBack()">
            <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
          </a>        
        </div>
      </div>
    </section>

    <!-- -------------------------- Step Form Section -------------------------- -->
    <section class="step-layout-right">
      <div
        class="step-layout-container"
        data-aos="fade-left"
        data-aos-duration="1500"
      >
        <h2 class="text-primary title" v-html="valuationTitle"></h2>
        <form class="text-center">
          <!-- Home Types List Group -->
          <ul class="list-group list-group-radio">
            <a
              href="javascript:void(0)"
              :class="sellFrequency == 'As soon as possible' ? 'active' : ''"
              v-on:click="selectSellFrequency('As soon as possible')"
              class="list-group-item list-group-item-action"
            >
              <span class="radio"></span><span>As soon as possible</span>
            </a>
            <a
              href="javascript:void(0)"
              :class="sellFrequency == '3-6 months' ? 'active' : ''"
              v-on:click="selectSellFrequency('3-6 months')"
              class="list-group-item list-group-item-action"
              ><span class="radio"></span><span>3-6 months</span>
            </a>
            <a
              href="javascript:void(0)"
              :class="sellFrequency == 'Over 6 months' ? 'active' : ''"
              v-on:click="selectSellFrequency('Over 6 months')"
              class="list-group-item list-group-item-action"
            >
              <span class="radio"></span><span>Over 6 months</span>
            </a>
            <a
              href="javascript:void(0)"
              :class="sellFrequency == 'Just finding home value' ? 'active' : ''"
              v-on:click="selectSellFrequency('Just finding home value')"
              class="list-group-item list-group-item-action"
            >
              <span class="radio"></span><span>Just finding home value</span>
            </a>
          </ul>
          <div class="text-left text-lg-right submit-btn-wrapper">
            <button type="button" class="btn btn-primary btn-lg submit-btn" v-on:click="submitForm()">
              Continue
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "PropertyValuationStepThree",
    data() {
        return {
            valuationStep: 3,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "Detached",
            sellFrequency: "As soon as possible",
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Third Step",
            valuationTitle: "How soon are you looking to sell?",
        };
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        //step-1 data
        if(sessionStorage.getItem('valuation_name')) {
            this.name = sessionStorage.getItem('valuation_name');
        }
        if(sessionStorage.getItem('valuation_email')) {
            this.email = sessionStorage.getItem('valuation_email');
        }
        if(sessionStorage.getItem('valuation_phone')) {
            this.phone = sessionStorage.getItem('valuation_phone');
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem("valuation_property_type");
        }
        //step-3 data
        if (sessionStorage.getItem("valuation_sell_frequency")) {
            this.sellFrequency = sessionStorage.getItem("valuation_sell_frequency");
        }
        //other
        if(sessionStorage.getItem('valuation_utm_source')) {
            this.utm_source = sessionStorage.getItem('valuation_utm_source');
        }
        if(sessionStorage.getItem('valuation_utm_medium')) {
            this.utm_medium = sessionStorage.getItem('valuation_utm_medium');
        }
        if(sessionStorage.getItem('valuation_utm_campaign')) {
            this.utm_campaign = sessionStorage.getItem('valuation_utm_campaign');
        }
        if(sessionStorage.getItem('valuation_utm_id')) {
            this.utm_id = sessionStorage.getItem('valuation_utm_id');
        }
        if(sessionStorage.getItem('valuation_utm_content')) {
            this.utm_content = sessionStorage.getItem('valuation_utm_content');
        }
        if(sessionStorage.getItem('valuation_data')) {
            sessionStorage.removeItem('valuation_data');
        }
        sessionStorage.setItem("valuation_sell_frequency",this.sellFrequency);
    },
    methods: {
        submitForm() {
            sessionStorage.setItem("valuation_sell_frequency",this.sellFrequency);
            window.location.href = "/properties/valuation/submit/data/step-4";
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-2";
        },
        selectSellFrequency(type) {
            this.sellFrequency = type;
        },
    },
  }
</script>